import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import AuthenticationFactorModalActionPicker
  from 'Views/Page/Content/Modal/Layouts/AuthenticationFactor/Layout/AuthenticationFactorModalActionPicker/AuthenticationFactorModalActionPicker';

const styles = (theme) => ({
  root: {},
  body: {
    padding: theme.spacing(0),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();
  const authenticationType = resource.selectedOptionPrompt('authenticationType');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Header
        title={authenticationType}
      />
      <BodyText
        text={`${authenticationType} is enabled.`}
      />
      <CenteredActions>
        <AuthenticationFactorModalActionPicker authenticationFactorResource={resource} />
      </CenteredActions>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
